import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { InternationalCallingPlan } from "./plan-table-data";

export const getInternationalCallingPlanColumns =
  (): ColumnDef<InternationalCallingPlan>[] => [
    {
      id: "destination",
      header: () => (
        <h3 className="text-left font-mobile text-[#27283D] text-sm sm:text-[0.925rem] lg:text-base font-bold leading-normal">
          Destination
        </h3>
      ),
      cell: ({ row }) => (
        <div className="text-left">
          <p className="w-40 sm:w-48 text-[#535862] text-[0.775rem] sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-5 lg:whitespace-nowrap">
            {row.original.destination}
          </p>
        </div>
      ),
    },
    {
      id: "includedMinutes",
      header: () => (
        <h3 className="text-center font-mobile text-[#27283D] text-sm sm:text-[0.925rem] lg:text-base font-bold leading-normal">
          Included Minutes
        </h3>
      ),
      cell: ({ row }) => (
        <div className="text-center">
          <p className="w-36 sm:w-44 text-[#535862] text-[0.775rem] sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-5 mx-auto">
            {row.original.includedMinutes}
          </p>
        </div>
      ),
    },
    {
      id: "textSMS",
      header: () => (
        <h3 className="text-right font-mobile text-[#27283D] text-sm sm:text-[0.925rem] lg:text-base font-bold leading-normal">
          Text SMS
        </h3>
      ),
      cell: ({ row }) => (
        <div className="text-right">
          <p className="w-36 sm:w-44 text-[#535862] text-[0.775rem] sm:text-[0.825rem] lg:text-sm font-normal leading-4 sm:leading-5 ml-auto">
            {row.original.textSMS}
          </p>
        </div>
      ),
    },
  ];
